import { createGetDrillInMessageIndicationsSelector } from '../state/reducer/selector.messages';
import _isEqual from 'lodash/isEqual';
var getMessageIndicationsListener = function (chatroomId, messageId) {
    var lastDrillInMessagesIndications;
    var getDrillInMessageIndications = createGetDrillInMessageIndicationsSelector(chatroomId, messageId);
    var indicationsChangesHandler = function (store, callback) {
        var state = store.getState();
        var drillInMessageIndications = getDrillInMessageIndications(state);
        var noChangesToPropogate = drillInMessageIndications && _isEqual(lastDrillInMessagesIndications, drillInMessageIndications);
        if (noChangesToPropogate) {
            return;
        }
        lastDrillInMessagesIndications = drillInMessageIndications;
        callback(drillInMessageIndications);
    };
    return indicationsChangesHandler;
};
export default getMessageIndicationsListener;
